import { initSehai } from "@pdfe/sehai";
import AIPNG from "@/assets/images/AI.gif";
import AIBODYPNG from "@/assets/images/AI-BODY.webp";

// 初始化aiChatBi
export default function initAiChatBiSdk(
  userId: string,
  userName: string,
  prompts: { prologue: string; question: string[] },
) {
  const config = {
    mode: "single",
    apiBase: "/api/intent-router/v1/chat/completions",
    appType: "open-completions",
    agentModel: "intent-router",
    extendBodyParams: {
      agent_name: "open-claw-det",
    },
    enableHistory: true,
    subtitle:
      prompts.prologue || "你好，我是小Q，我可以为你分析质量相关的问题哦。你可以进行以下操作： 1.进行运单的奖惩分析; 2.进行运单的赔偿分析。",
    welcomeAvatar: AIBODYPNG,
    userId,
    userName,
    headerConfig: {
      title: "快件质量智能体",
      titleType: "text",
      logo: AIPNG,
    },
    presetQuestions: prompts.question || [
      "要分析运单的奖惩情况？",
      "要分析运单的赔偿情况？",
    ],
    input: {
      userNo: userId,
    },
  };
  const aiChatBi = initSehai(config as any);
  return { aiChatBi, config };
}
